module.exports = __webpack_public_path__ + "static/media/arrow_to_ticket.4c9daca2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow/arrow_to_ticket.svg
// module id = 762
// module chunks = 0